import { render } from "./MenuSwap.vue?vue&type=template&id=0732f00e"
import script from "./MenuSwap.vue?vue&type=script&lang=js"
export * from "./MenuSwap.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/MenuSwap.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0732f00e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0732f00e', __exports__)) {
    api.reload('0732f00e', __exports__)
  }
  
  module.hot.accept("./MenuSwap.vue?vue&type=template&id=0732f00e", () => {
    api.rerender('0732f00e', render)
  })

}


export default __exports__